import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-school-class-compare-block-legend',
  templateUrl: './school-class-compare-block-legend.component.html',
  styleUrls: ['./school-class-compare-block-legend.component.scss']
})
export class SchoolClassCompareBlockLegendComponent {

  @Input('data') data: any;

}
